import { useEffect } from 'react';

import { TLang, changeLanguage } from '@webtrader/core/i18n';

import { checkIsNative } from '../validators/device';

const CHANNEL_NAME = 'language-channel';
const SYNC_RESET_DELAY = 100;
let isSyncing = false;

interface ILanguageChangeMessageData {
  lang: TLang;
}

export const broadcastLanguageChangeMessage = ({ lang }: ILanguageChangeMessageData) => {
  if (checkIsNative() || isSyncing) {
    return;
  }
  const channel = new BroadcastChannel(CHANNEL_NAME);
  channel.postMessage({ lang });
  channel.close();
};

export const useSyncLanguage = (currentLanguage: string) => {
  useEffect(() => {
    const channel = new BroadcastChannel(CHANNEL_NAME);
    let timeoutId: NodeJS.Timeout | null = null;

    channel.onmessage = async (event: MessageEvent<ILanguageChangeMessageData>) => {
      const { lang: syncedLanguage } = event.data ?? {};

      const shouldRefreshTradingAccount = !!syncedLanguage && !!currentLanguage && syncedLanguage !== currentLanguage;

      if (shouldRefreshTradingAccount) {
        isSyncing = true;
        try {
          await changeLanguage({ language: syncedLanguage });
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Failed to sync language:', error);
        } finally {
          timeoutId = setTimeout(() => {
            isSyncing = false;
          }, SYNC_RESET_DELAY);
        }
      }
    };

    return () => {
      channel.close();
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [currentLanguage]);
};
